/**
 * Auth Service
 * Handles authentication-related API calls
 */
import BaseApiService from '../base/BaseApiService';
import type { AuthResponse, LoginCredentials, User } from '@app-types';

class AuthService extends BaseApiService {
  /**
   * Login with credentials
   * Note: This method is kept for compatibility but won't be used with MSAL authentication
   */
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    throw new Error('Use MSAL authentication instead of this method');
  }

  /**
   * Get current authenticated user
   */
  async getCurrentUser(): Promise<User> {
    return this.get<User>('/auth/me');
  }

  /**
   * Logout
   * Note: MSAL logout is handled by AuthContext
   */
  logout(): void {
    console.log('Logout handled by MSAL AuthContext');
  }
}

export const authService = new AuthService();
export default authService;
